module.exports = __webpack_public_path__ + "static/media/cross.f41ac3af.svg";